export const requiredRule = (v: any | undefined | null) => !!v || 'This field is required'

export const requiredListRule = (v: any[] | undefined | null) => (!!v && v.length > 0) || 'This field is required'

export const noSpaceRule = (v: string) => !v.includes(' ') || 'It is not allowed to use "space" character'
